import { Button, Card, Empty, Form, Input, Modal, Table } from 'antd';
import React, { useEffect } from 'react';
import { fetchData, postData, putData } from '../../helper/api';
import moment from 'moment';
import { date } from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { formatCurrency } from '../../helper/formatCurrency';
import { parse } from 'date-fns';
import { useGeneral } from '../../contexts/GeneralContext';

const Expenses = (props) => {
    const { trigerFetchData, setTrigerFetchData } = props
    const [dataExpenses, setDataExpenses] = React.useState([])
    const [openModalAddExpenses, setOpenModalAddExpenses] = React.useState(false)
    const { getProfile, getShiftNow } = useGeneral()
    const [shiftNow, setShiftNow] = React.useState(getShiftNow)
    const [userData, setUserData] = React.useState(getProfile)

    const formik = useFormik({
        initialValues: {
            user_id: userData?.id,
            shift_id: shiftNow?.id,
            name: '',
            amount: '',
            description: '',
            date: moment().format('YYYY-MM-DD'),
            payment_method: 'cash',
            finance_account_id: 2,
            finance_category_id: 2,
        },
        onSubmit: values => {
            const formattedValues = {
                ...values,
                amount: parseFloat(values.amount),
            };


            if (formik.values.id) {
                putData(`/expenses/${formik.values.id}`, formattedValues)
                    .then((response) => {
                        formik.resetForm();
                        toast.success('Expense updated successfully');
                        setOpenModalAddExpenses(false);
                        setTrigerFetchData(!trigerFetchData);
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error('Failed to update expense');
                    });
            } else {
                postData('/expenses-shift', formattedValues)
                    .then((response) => {
                        formik.resetForm();
                        toast.success('Expense added successfully');
                        setOpenModalAddExpenses(false);
                        setTrigerFetchData(!trigerFetchData);
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error('Failed to add expense');
                    });
            }
        }
    })

    useEffect(() => {
        setShiftNow(getShiftNow)
        setUserData(getProfile)
    }, [getShiftNow, getProfile])

    useEffect(() => {
        // Get data expenses
        fetchData('/expenses-shift', {
            params: {
                shift_id: shiftNow?.id
            }
        })
            .then((response) => {
                const data = response.data.data.expenses
                const moveData = data.map((item) => {
                    return {
                        ...item,
                        date_time: item.createdAt ? moment(item.createdAt).format('DD MMM YYYY HH:mm:ss') : '-',
                        amount: parseInt(item.amount || 0),
                    }
                })
                setDataExpenses(moveData)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [trigerFetchData])

    const columnsShift = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Date Time',
            dataIndex: 'date_time',
            key: 'date_time',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record) => (
                <>{formatCurrency(record.amount)}</>
            )
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <div>
                    <Button
                        className="bg-blue-500 text-white"
                        onClick={() => {
                            formik.setValues(record)
                            setOpenModalAddExpenses(true)
                        }}
                    >
                        Edit
                    </Button>
                </div>
            ),
        },
    ]

    return (
        <div>
            <Modal
                title="Tambah Pengeluaran"
                open={openModalAddExpenses}
                onCancel={() => setOpenModalAddExpenses(false)}
                onOk={() => setOpenModalAddExpenses(false)}
                footer={null}
            >
                <Form layout="vertical" onSubmit={formik.handleSubmit}>
                    <Form.Item
                        label="Nama Pengeluaran"
                        required
                        validateStatus={formik.errors.name && formik.touched.name ? 'error' : ''}
                        help={formik.errors.name && formik.touched.name ? formik.errors.name : ''}
                    >
                        <Input
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            placeholder="Contoh: Bensin, ATK, dll"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Jumlah"
                        required
                        validateStatus={formik.errors.amount && formik.touched.amount ? 'error' : ''}
                        help={formik.errors.amount && formik.touched.amount ? formik.errors.amount : ''}
                    >
                        <Input
                            name="amount"
                            value={formik.values.amount}
                            onChange={formik.handleChange}
                            type="number"
                            placeholder="Masukkan jumlah pengeluaran"
                            prefix="Rp"
                        />
                    </Form.Item>

                    <Form.Item label="Deskripsi">
                        <Input.TextArea
                            name="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            placeholder="Deskripsi pengeluaran (opsional)"
                            rows={3}
                        />
                    </Form.Item>

                    <div className="flex justify-end gap-2">
                        <Button onClick={() => setOpenModalAddExpenses(false)}>
                            Batal
                        </Button>
                        <Button
                            className="bg-blue-500 text-white hover:bg-blue-600"
                            onClick={formik.handleSubmit}
                            disabled={!formik.values.name || !formik.values.amount}
                        >
                            Tambah Pengeluaran
                        </Button>
                    </div>
                </Form>
            </Modal>

            <div className='flex justify-start mb-2'>
                <Button className="bg-blue-500 text-white"
                    onClick={() => {
                        formik.resetForm()
                        setOpenModalAddExpenses(true)
                    }
                    }>Tambah Pengeluaran</Button>
            </div>

            <Card>
                <div className="table-responsive" >
                    <Table
                        columns={columnsShift}
                        dataSource={dataExpenses}
                        className="ant-border-space"
                        locale={{
                            emptyText: <Empty description="Data not found" />,
                        }}
                        pagination={{
                            position: ['bottomCenter'],
                            pageSize: 10,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20', '30', '40'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        }}
                    />
                </div>
            </Card>
        </div>
    );
};

export default Expenses;